import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import renderStakeSaverCompliance from "./stake-saver-compliance";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useStakeDebit } from "../../../CustomHooks/Queries";

import { modalVariants } from "../../../Utils/constants";

import { StakeCardFrontRotated } from "../../../Assets/Images";

export default function renderApplyStakeChecking(modalContext, props) {
  const { updateModalComponent, setModalVariant, setModalClassName, setModalPromoComponent } = modalContext;

  updateModalComponent(() => <ApplyStakeChecking {...props} />);
  setModalPromoComponent(null);
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("position-close-button-over-content light-close-button");
}

const ApplyStakeChecking = ({ applyOnMount, ...props }) => {
  const [renderApplyDialog, setRenderApplyDialog] = useState(false);

  const modalContext = useModalContext();
  const { onModalClose } = modalContext;

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { data: stakeDebit } = useStakeDebit();

  useEffect(() => {
    if (applyOnMount) {
      navigate("/apply-stake-checking", { state: { previousPathname: pathname } });
      onModalClose();
    }
    //eslint-disable-next-line
  }, [applyOnMount]);

  const handleNextButtonClick = () => {
    if (!renderApplyDialog) {
      setRenderApplyDialog(true);
    } else {
      if (stakeDebit?.data?.data?.stake_debit_notification?.excluded_from_stake_saver_charges) {
        navigate("/apply-stake-checking", { state: { previousPathname: pathname } });
        onModalClose();
      } else {
        renderStakeSaverCompliance(modalContext, {
          onAccept: () => renderApplyStakeChecking(modalContext, { applyOnMount: true, ...props }),
        });
      }
    }
  };

  return (
    <>
      <div className="modal-image-carousel position-relative">
        <div className="modal-image stake-debit-single-card">
          <img src={StakeCardFrontRotated} alt="" />
        </div>
        <div className="carousel-indicators">
          {Array.from(new Array(2)).map((_, idx) => (
            <button
              key={idx}
              data-bs-target=""
              className={!!renderApplyDialog === !!idx ? "active" : ""}
              onClick={() => setRenderApplyDialog(!!idx)}
            ></button>
          ))}
        </div>
      </div>
      <div className="modal-dialog-content">
        <h3 className="modal-status-title text-center mb-0">
          {!renderApplyDialog
            ? stakeDebit?.data?.data?.card_onboarding_page_1_header
            : stakeDebit?.data?.data?.card_onboarding_page_2_header}
        </h3>
        <span className="modal-content-text text-center mt-1">
          {!renderApplyDialog
            ? stakeDebit?.data?.data?.card_onboarding_page_1_body
            : stakeDebit?.data?.data?.card_onboarding_page_2_body}
        </span>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={handleNextButtonClick}>{!renderApplyDialog ? "Next" : "Apply Now"}</PrimaryButton>
        {renderApplyDialog && (
          <PrimaryButton className="secondary-colors" onClick={setRenderApplyDialog.bind(this, false)}>
            Back
          </PrimaryButton>
        )}
      </div>
      {renderApplyDialog && !!stakeDebit?.data?.data?.disclosure_text && (
        <span className="text-xxs-regular color--american-silver text-center mt-0 mb-4 mx-sm-6 mx-4">
          {stakeDebit?.data?.data?.disclosure_text}
        </span>
      )}
    </>
  );
};
